var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"choose-client__card"},[_c('v-icon',{staticClass:"roundedIconLight",class:_vm.windowWidth <= 1280 ? 'largeBlownIcon' : 'blownIcon'},[_vm._v("\n    how_to_reg\n  ")]),_c('auto-suggestion-input')],1)}
var staticRenderFns = []

export { render, staticRenderFns }